import { Box } from "@mui/material"
import React from "react"

export const Logo = () => {
    return (
        <Box
            component="img"
            src={"/logo/c2p-logo.webp"}
            alt="C2P Logo"
            width="97px"
            height="49px"
        />
    )
}
